const APK_URL = 'https://storage.googleapis.com/spacetech2/abc777/ABC777.apk?ignoreCache=1';

export function listenForPwaInstall() {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    window.__abc777PwaPrompt = event;
  });
}

export async function installPwaApp() {
  const promptEvent = typeof window !== 'undefined' ? window.__abc777PwaPrompt : null;
  if (promptEvent) {
    promptEvent.prompt();
    await promptEvent.userChoice;
    window.__abc777PwaPrompt = null;
    return 'pwa';
  }

  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  if (/android/i.test(userAgent)) {
    window.location.href = APK_URL;
    return 'apk';
  }

  return 'unsupported';
}
